import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FadeIn } from '../../../../../../core/util/commonCssAnimations';
import { ie10Up } from '../../../../../../core/util/styledComponents';
import SlotShape from '../../../../../../shapes/Slot';
import Slot from './Slot';
import styled, { keyframes } from 'styled-components';
import { emptyFunction } from '../../../../../../core/util/function';
import { safeGet } from '../../../../../../core/util/object';
import { getSlotSelectionProperties, getAvailableSlots } from './util';
import { EMPTY_ARRAY, isEmptyArray } from '../../../../../../core/util/array';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);

  @media (max-width: 330px) {
    grid-template-columns: repeat(3, auto);
  }

  ${ie10Up`
    display: -ms-flexbox;
    -ms-flex-wrap: wrap;
  `}
`;

const SlotContainer = styled.div`
  margin: 4px;
  animation: ${FadeIn} 300ms linear;
`;

const isSelected = (slot, selectedSlots = EMPTY_ARRAY) =>
  selectedSlots.some(s => s.appointmentDate === slot.appointmentDate);

class FullTimeSlotGrid extends Component {
  componentDidMount = () => {
    const { selectedSlots, slots, shouldSelectFirstSlotAsInitialValue } = this.props;
    if (isEmptyArray(selectedSlots) && shouldSelectFirstSlotAsInitialValue) {
      const defaultSlot = safeGet(getAvailableSlots(slots))('0');
      if (defaultSlot) {
        this.handleSelect(defaultSlot);
      }
    }
  };

  handleSelect = slot => {
    if (slot.availability < 1) {
      return;
    }

    const { slots } = this.props;
    const selectionProperties = getSlotSelectionProperties(slots);
    this.props.handleSelectedSlot(slot, selectionProperties);
  };

  render() {
    const { slots, timeZone, className, darkTheme, selectedSlots } = this.props;

    return (
      <Container className={className}>
        {slots.map(slot => (
          <SlotContainer onClick={() => this.handleSelect(slot)} key={slot.appointmentDate}>
            <Slot
              slot={slot}
              isSelected={isSelected(slot, selectedSlots)}
              darkTheme={darkTheme}
              timeZone={timeZone}
            />
          </SlotContainer>
        ))}
      </Container>
    );
  }
}

FullTimeSlotGrid.propTypes = {
  slots: PropTypes.arrayOf(SlotShape),
  timeZone: PropTypes.string,
  className: PropTypes.string,
  darkTheme: PropTypes.bool,
  handleSelectedSlot: PropTypes.func,
  selectedSlots: PropTypes.arrayOf(SlotShape),
  shouldSelectFirstSlotAsInitialValue: PropTypes.bool,
};

FullTimeSlotGrid.defaultProps = {
  handleSelectedSlot: emptyFunction,
};

export default FullTimeSlotGrid;
